import store from '@/store';
import {
    OptionJumpType,
    QuestionJumpType,
    QuestionSepcialFlag,
    QuestionType,
    RelType
} from '@/libs/enum';
import { findQuestionIndex } from './question-tool';
import MutipleJumpCondition from '@/libs/multi-jump-condition';

/**
 * 判断是否有答案
 * @param {*} answer
 * @returns
 */
export function hasAnswer(answer) {
    return !!(answer && answer.length);
}

/**
 * 两数组的交集
 * @param {*} arr1
 * @param {*} arr2
 * @returns
 */
export function intersection(arr1 = [], arr2 = []) {
    const c = arr1.filter(v => {
        return arr2.indexOf(v) > -1;
    });
    return c;
}

/**
 * 判断两个数组是否相等
 * @param {*} arr1
 * @param {*} arr2
 * @returns
 */
export function isSameArray(arr1 = [], arr2 = []) {
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);
    const isSameSet = [...set1].every(o => set2.has(o)) && [...set2].every(o => set1.has(o));
    return isSameSet;
}

/**
 * 获取所有问题列表
 * @returns
 */
export function getQuestions(page = {}) {
    const questions = Object.values(page).flat() || [];
    return questions;
}

/**
 * 根据qid查询出问题对象
 * @param {*} identifier
 * @returns
 */
export function getQuestionById(identifier, questions = []) {
    const targetQuestion = questions.find(q => q.qidentifier === identifier);
    return targetQuestion;
}

/**
 * 判断问题是否有关联关系
 * @param {*} question
 * @returns
 */
export function haveQuestionRel(question = {}) {
    return !!(
        question.questionRelConfig &&
        question.questionRelConfig.relConfigs &&
        question.questionRelConfig.relConfigs.length
    );
}

/**
 * 根据关联关系去设置被关联的问题对象
 * @param {*} relConfgs
 */
export function setBerelQuestions(questions = [], targetQuestion = {}) {
    const { relConfigs } = targetQuestion.questionRelConfig;
    relConfigs.forEach(relConfig => {
        const question = getQuestionById(relConfig.qidentifier, questions);
        const config = question.berelConfigs.find(
            ref => ref.qidentifier === targetQuestion.qidentifier
        );
        if (!config) {
            question.berelConfigs.push({
                ...relConfig,
                originIdentifier: targetQuestion.qidentifier
            });
        }
    });
}

/**
 * 当前选项是否有被关联关系
 * @param {*}} question
 */
export function haveQuestionBeRel(question = {}) {
    return question.berelConfigs && question.berelConfigs.length;
}

/**
 * 题目的答案是否命中关联关系
 * @param {*} answer
 * @param {*} question
 * @returns
 */
export function isHitQuestionRel(answer, question) {
    if (!haveQuestionBeRel(question)) {
        return [];
    }
    if (!answer || !answer.length) {
        return [];
    }
    if (
        QuestionType.fillblank === question.questionType ||
        QuestionType.page === question.questionType
    ) {
        return [];
    }
    let hitRels = [];
    if (QuestionType.single === question.questionType) {
        hitRels = question.berelConfigs.filter(conf => {
            if (conf.qidentifier === question.qidentifier) {
                if (conf.operator === RelType.and && conf.optionIdentifiers.join('') === answer) {
                    // 且的关系
                    return true;
                } else if (
                    conf.operator === RelType.or &&
                    conf.optionIdentifiers.includes(answer)
                ) {
                    return true;
                }
                return false;
            }
            return false;
        });
    } else {
        hitRels = question.berelConfigs.filter(conf => {
            if (conf.qidentifier === question.qidentifier) {
                if (conf.operator === RelType.and) {
                    // 且的关系
                    return isSameArray(conf.optionIdentifiers, answer);
                }
                const filterArr = conf.optionIdentifiers.filter(v => answer.indexOf(v) > -1);
                return !!filterArr.length;
            }
            return false;
        });
    }
    return hitRels;
}

/**
 * 检查题目的关联关系是否都已经被标记
 */
export function checkQuestionRelFlags(relConfig = {}) {
    if (relConfig.operator === RelType.and) {
        const rels = relConfig.relConfigs.filter(conf => conf.flag);
        return rels.length === relConfig.relConfigs.length;
    }
    if (relConfig.operator === RelType.or) {
        const rels = relConfig.relConfigs.filter(conf => conf.flag);
        return !!rels.length;
    }
    return false;
}

/**
 * 给有关联的问题进行打标记
 * @param {*} question 问题对象
 * @param {*} hitRefs 选项答案命中了几个关联关系
 * @returns
 */
export function markQuestionRelHit(question = {}, hitRefs = []) {
    const { page, currentPage } = store.state;
    const questions = getQuestions(page);
    question.berelConfigs.forEach(berefConf => {
        const hitRef = hitRefs.find(ref => ref.originIdentifier === berefConf.originIdentifier);
        if (hitRef) {
            const originQuestion = getQuestionById(hitRef.originIdentifier, questions);
            const rel = originQuestion.questionRelConfig.relConfigs.find(
                c => c.qidentifier === question.qidentifier
            );
            if (rel) {
                rel.flag = true;
            }
            const check = checkQuestionRelFlags(originQuestion.questionRelConfig);
            // console.log('--->>>', originQuestion.questionRelConfig, check);
            // 题目的所有关联关系都被标记了，则当前这题应该被显示
            if (check) {
                originQuestion.show = true;
            } else {
                originQuestion.show = false;
            }
        } else {
            const originQuestion = getQuestionById(berefConf.originIdentifier, questions);
            const rel = originQuestion.questionRelConfig.relConfigs.find(
                c => c.qidentifier === question.qidentifier
            );
            if (rel) {
                rel.flag = false;
                originQuestion.show = false;
            }
        }
    });
    return page[currentPage];
}

/**
 * 判断问题的关联到的问题选择的答案是否符合当前问题的关联关系
 * @param {*} targetQuestion
 * @param {*} refConfig
 * @returns
 */
export function checkTargetQuestionOk(targetQuestion = {}, refConfig = {}) {
    const { operator, optionIdentifiers } = refConfig;
    const { anwser } = targetQuestion;
    if (!anwser || !anwser.length) {
        return false;
    }
    let answerWrap = [];
    if (targetQuestion.questionType === QuestionType.single) {
        answerWrap = [anwser];
    }
    if (targetQuestion.questionType === QuestionType.multi) {
        answerWrap = [...anwser];
    }
    let isCheck = false;
    if (operator === RelType.or) {
        const arr = intersection(optionIdentifiers || [], answerWrap);
        isCheck = !!arr.length;
    } else {
        const isSame = isSameArray(optionIdentifiers || [], answerWrap);
        isCheck = isSame;
    }
    return isCheck;
}

/**
 * 判断一个问题关联的问题的答案是否符合关联的配置
 * @param {*} question
 * @returns
 */
export function checkQuestionRelOK(question = {}) {
    if (!haveQuestionRel(question)) {
        return false;
    }
    const { page } = store.state;
    const allQuestions = getQuestions(page);
    const { operator, relConfigs } = question.questionRelConfig;
    const checkList = [];
    for (let i = 0; i < relConfigs.length; i++) {
        const config = relConfigs[i];
        const targetQuestion = getQuestionById(config.qidentifier, allQuestions);
        const isCheck = checkTargetQuestionOk(targetQuestion, config);
        checkList.push(isCheck);
    }
    if (operator === RelType.or) {
        return checkList.includes(true);
    }
    if (operator === RelType.and) {
        return checkList.filter(flag => flag === true).length === checkList.length;
    }
}

/**
 * 检查group是否都是显示的
 * @param {*} group
 */
export function checkGroupExistShow(group = []) {
    const showGroup = group.filter(q => q.show === true);
    return !!showGroup.length;
}

// 获取当前分页最大有页数
export function getMaxPageNum(page = {}) {
    const all = Object.keys(page);
    if (!all || !all.length) {
        return 0;
    }
    return Number(all[all.length - 1]);
}

function hasCommonElement(arr1, arr2) {
    return arr1.some(element => arr2.includes(element));
}
function hasArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false; // 数组长度不相等，直接返回 false
    }
    return arr1.every(element => arr2.includes(element));
}

/**
 * 判断当前题目的引用关系是否满足，
 * 并根据满足条件后判断是否显示（配置端可以配置满足条件后显示或者不显示）
 * @param {*} question
 */
export function checkRefShow(question) {
    if (!haveQuestionRel(question)) {
        return false;
    }
    const { page } = store.state;
    const questions = getQuestions(page);
    const { questionRelConfig } = question;
    const operator = questionRelConfig.operator || RelType.or;
    const relConfigs = questionRelConfig.relConfigs || [];

    const refs = [];
    for (const refConfig of relConfigs) {
        const refOperator = refConfig.operator;
        const { optionIdentifiers } = refConfig;
        const { qidentifier } = refConfig;
        const targetQ = getQuestionById(qidentifier, questions);
        // 引用关系的目标问题不存在，或者目标问题当前已经被隐藏，这当前这条引用规则应该是隐藏的
        if (!targetQ || !targetQ.show) {
            refs.push(false);
            continue;
        }
        const { anwser } = targetQ;
        if (!anwser || !anwser.length) {
            refs.push(false);
            continue;
        }
        if (refOperator === RelType.or) {
            if (targetQ.questionType === QuestionType.single) {
                refs.push(optionIdentifiers.includes(anwser));
            } else if (targetQ.questionType === QuestionType.multi) {
                refs.push(hasCommonElement(optionIdentifiers, anwser));
            } else {
                refs.push(false);
            }
        } else if (refOperator === RelType.and) {
            if (targetQ.questionType === QuestionType.single) {
                refs.push(optionIdentifiers.includes(anwser));
            } else if (targetQ.questionType === QuestionType.multi) {
                refs.push(hasArraysEqual(optionIdentifiers, anwser));
            } else {
                refs.push(false);
            }
        }
    }
    let isOK = false;
    if (operator === RelType.or) {
        isOK = refs.includes(true);
    }
    if (operator === RelType.and) {
        isOK = refs.every(element => element === true);
    }

    const { visible } = questionRelConfig;
    // 当前问题只是否可见：当配置确定为true或者visible字段不存在时候都表示满足关系才可见
    const visialeFlag = visible === true || visible === undefined;
    if (isOK) {
        // 满足配置的关联关系
        return visialeFlag;
    } else {
        // 不满足配置的关联关系
        return !visialeFlag;
    }
}
/**
 * 根据当前问题，获取应该跳转到目标题目的索引。
 * 当前question的回答，进行跳题目逻辑
 * @param {*} question
 * @returns
 */
export function questionJump(question) {
    const answer = question.anwser;
    const { page } = store.state;
    const questions = getQuestions(page);
    const { questionJumpConfig, questionType } = question;
    if (!questionJumpConfig) {
        return;
    }
    const {
        jumpToEnd,
        jumpType,
        jumpToQuestion,
        optionJumpConfigs = [],
        jumpCondition,
        jumpConditionType,
        jumpConditionOptionIdentifiers = []
    } = questionJumpConfig;
    const start = findQuestionIndex(questions, question.qidentifier);
    let end = start;
    // 无条件跳题
    if (jumpType === QuestionJumpType.byNothing) {
        if (jumpToEnd) {
            end = questions.length;
        } else {
            end = findQuestionIndex(questions, jumpToQuestion);
        }
    }
    // 根据选项跳题目
    else if (jumpType === QuestionJumpType.byOption) {
        // 单选题按选项跳题目
        if (questionType === QuestionType.single) {
            const jumpOption = optionJumpConfigs.find(item => item.optionIdentifier === answer);
            if (jumpOption) {
                switch (jumpOption.jumpType) {
                    case OptionJumpType.submitInvalid:
                        // 提交未无效问卷 -100 标识为提交无效问卷
                        end = QuestionSepcialFlag.submitInvalid;
                        break;
                    case OptionJumpType.toEnd:
                        end = questions.length;
                        break;
                    case OptionJumpType.toTarget:
                        end = findQuestionIndex(questions, jumpOption.jumpToQuestion);
                        break;
                    case OptionJumpType.orderNext:
                        // 顺序下一题
                        break;
                    default:
                        break;
                }
            }
        }
        // 多选题按选项跳题目
        else if (questionType === QuestionType.multi) {
            const mutiJumpCondition = new MutipleJumpCondition();
            // 判断选择的答案是否满足跳题目的配置逻辑
            const isOk = mutiJumpCondition.isValidMultipleJumpCondition(
                answer,
                jumpCondition,
                jumpConditionOptionIdentifiers
            );
            // 符合跳题逻辑
            if (isOk) {
                switch (jumpConditionType) {
                    case OptionJumpType.submitInvalid:
                        // 提交未无效问卷 -100 标识为提交无效问卷
                        end = QuestionSepcialFlag.submitInvalid;
                        break;
                    case OptionJumpType.toEnd:
                        end = questions.length;
                        break;
                    case OptionJumpType.toTarget:
                        end = findQuestionIndex(questions, jumpToQuestion);
                        break;
                    case OptionJumpType.orderNext:
                        // 顺序下一题
                        break;
                    default:
                        break;
                }
            }
        }
    } else {
        // 暂时没有其他类型
    }
    if (end > start) {
        for (let i = start + 1; i < end; i++) {
            const nextQue = questions[i];
            nextQue.show = false;
        }
    }
    return end;
}
